export default __webpack_public_path__ + "static/media/App.tsx.6b27cf13.txt";